import React, { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";
const Footer = (props) => {
  return (
    <Fragment>
      {/* <footer className="footer" style={{ position: "sticky" }}> */}
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col className="footer-copyright text-center">
              <p className="mb-0">
                Copyright 2023 © <span>{}</span>
                {
                  <a href="https://www.multicodesolution.com/">
                    Multicode-Solution
                  </a>
                }
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;
